angular
    .module('tradersyard')
    .factory('webinar-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        hash = $flex.$hash.get();
                        tab =
                            [
                                'timeline',
                                'participant',
                                'request',
                                'document',
                                'video',
                                'photo',
                                'trade_sharing',
                                'analysis_sharing',
                            ].indexOf(hash) !== -1
                                ? hash
                                : 'timeline';
                        filter.set(tab);
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    set: function (name) {
                        tab = name;
                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);

                        if ($flex.$hash.get() !== name) $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('webinar-read-ctrl', [
        '$rootScope',
        '$scope',
        '$flex',
        'graph-webinar-factory',
        'webinar-read-filter',
        '$rootScope',
        'GraphParticipantService',
        'GuidFactory',
        'WebSocket',
        '$flex.array',
        '$q',
        'updatesService',
        '$window',
        'RequestManagerFactory',
        'PaginationFactory',
        '$location',
        'AuthService',
        'MeetingService',
        '$timeout',
        '$uibModal',
        function (
            $rootScope,
            $scope,
            $flex,
            webinarFactory,
            $filter,
            $root,
            ParticipantService,
            GuidFactory,
            $socket,
            $array,
            $q,
            $updates,
            $window,
            RequestManagerFactory,
            $paginationFactory,
            $location,
            Auth,
            MeetingService,
            $timeout,
            $uibModal
        ) {
            $scope.Guid = GuidFactory.Generate();
            $scope.participantRole = undefined;
            $scope.requests = 0;
            $scope.adminRoles = ['owner', 'executive', 'presenter'];

            var canceler = $q.defer();

            /**
             * We need to use this function in order to add a "link" for guests on the page,
             * because open-authentication-dialog directive is blocking simple <a href> tags.
             * @param $event
             */
            $scope.goToLoginPage = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $window.location.href = '/login?redirect=' + $window.location.href;
            };

            $scope.setParticipantRole = function (role) {
                $scope.participantRole = !!role ? role : undefined;
                setTimeout(function () {
                    $rootScope.$broadcast('participant:role', role);
                });
            };

            $scope.openCheckoutModal = function (node, $request) {
                console.log('Opening checkout for Webinar', node, $request);
                node.request_id = node.request_id ?? $request.id;
                node.is_requested = true;

                if (featureDisabled('paid-events')) {
                    location.reload();
                    return; // feature is disabled, so don't show the modal
                }

                if (!node.is_paid) {
                    return; // not a paid event, so don't show the modal
                }

                const resolve = {
                    eventId: () => node.id,
                    joinRequestId: () => node.request_id ?? $request.id,
                };

                // Open a modal window that the user won't be able to close that easily.
                $uibModal.open({ component: 'tyEventCheckoutModal', resolve, backdrop: 'static', keyboard: false });
            };

            $scope.userCanEditComment = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (
                    node.photos.length <= 0 &&
                    node.videos.length <= 0 &&
                    node.documents.length <= 0 &&
                    node.owner.id === $rootScope.me.id
                ) {
                    return true;
                }

                return false;
            };

            $scope.userCanDeleteMessage = function (node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (node.owner.id === $rootScope.me.id || $scope.adminRoles.includes($scope.participantRole)) {
                    return true;
                }

                return false;
            };

            $scope.node = {};
            angular.extend($scope, $flex.data);

            $scope.next_session_time = undefined;

            angular.forEach($scope.node.executions, function (val) {
                if (typeof $scope.next_session_time === 'undefined') {
                    if (moment(val.started_at).unix() > moment().unix()) {
                        $scope.next_session_time = val.started_at;
                    }
                }
            });

            $scope.Request = RequestManagerFactory.Init($scope.node.id, 'webinar', $scope);
            $scope.Request.Count = $scope.requests;

            webinarFactory.queryRelatedProducts($scope.node.id).then(function (response) {
                $scope.relatedProducts = response.data.data;
            });

            $scope.reverseOrder = true;
            $scope.sortField = 'created_at';

            $scope.sortBy = function (sortField) {
                $scope.reverseOrder = $scope.sortField === sortField ? !$scope.reverseOrder : false;
                $scope.sortField = sortField;

                $scope.participants.SortQuery({
                    field: sortField,
                    sort: $scope.reverseOrder ? 'desc' : 'asc',
                });
            };

            $scope.downloadParticipantsLink = function () {
                var groupId = $scope.node.id;

                return '/webinar/' + groupId + '/participants/download';
            };

            //
            $scope.participants = ParticipantService.Get($scope.node.id, 'webinar');
            $scope.participants.Count = $scope.node.participants;
            $socket.emit('join:webinar', [$scope.node.id]);
            //
            $scope.filter = $filter;
            $scope.params = {
                timeline: {
                    page: 0,
                },
                participants: {
                    page: 0,
                    limit: 25,
                },
                documents: {
                    page: 0,
                },
                photos: {
                    page: 0,
                },
                videos: {
                    page: 0,
                },
            };
            $scope.timeline = [];
            $scope.posts = [];
            // $scope.participants = [];
            $scope.documents = [];
            $scope.photos = [];
            $scope.videos = [];
            $scope.progress = {
                photos: [],
                videos: [],
                documents: [],
            };
            $scope.ownerId = $scope.node.owner.id;

            $scope.Join = function (node) {
                $scope.participants.Join(node.id, $scope.Guid, function () {
                    $scope.node.participants = $scope.participants.Data;
                    $scope.node.im_participant = true;

                    $timeout(function () {
                        if ($scope.node.technology === 'other-technology') {
                            location.replace($scope.node.technology_url);
                        }
                    }, 0);
                });
            };

            $scope.Leave = function (node) {
                if (node.subscription ?? false) {
                    const resolve = {
                        entry: () => 'webinar',
                        entryId: () => node.id,
                    };

                    const modal = $uibModal.open({ component: 'tyParticipantLeaveModal', resolve });

                    return modal.result
                        .then(() => {
                            window.location.reload();
                        })
                        .catch(() => console.log('modal dismissed'));
                }

                $scope.participants.Leave(node.id, $scope.Guid, function () {
                    $timeout(function () {
                        $scope.node.participants = $scope.participants.Data;
                        $scope.node.im_participant = false;
                    }, 0);
                });
            };

            $root.$on('invitation-accept', function () {
                webinarFactory.getMyProfile().then(function (profile) {
                    if (profile.data.data.google_sync) {
                        webinarFactory.googleCalendarSync($scope.node);
                    }
                });
            });

            $root.$on('role-change', function (event, data) {
                window.location.reload();
            });

            $scope.assignRole = function (node) {
                $root.$broadcast('open:assign-role:dialog', {
                    node: node,
                    entry: { type: 'webinar', id: $scope.node.id },
                });
            };

            $scope.removeParticipant = function (node) {
                $rootScope.$broadcast('open:confirm-participant-remove:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.selectExpire = function (node) {
                $rootScope.$broadcast('open:select-participant-expire:dialog', {
                    node: node,
                    service: $scope.participants,
                });
            };

            $scope.cancelExpire = function (node) {
                $scope.participants.Expire(node.id, (node.expired_at = null));
            };

            $scope.upload = {
                descriptionImage: uploadDescriptionImage,
                headerImage: uploadHeaderImage,
                error: function (error) {
                    $root.$broadcast('graph-modal-show', {
                        title: 'Error',
                        content: error,
                    });
                },
                photo: function (node) {
                    if ($scope.photo && $scope.form.photo.$valid === true) {
                        var photo = $scope.photo;
                        $scope.progress.photos.push({
                            name: photo.name,
                        });

                        webinarFactory
                            .photos(node.id)
                            .upload({
                                name: $scope.photo.name,
                                photo: $scope.photo.base,
                            })
                            .then(function (response) {
                                $scope.progress.photos = $array.$splice(
                                    $scope.progress.photos,
                                    { name: photo.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.photos.unshift(response.data.data);

                                    if ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') {
                                        $rootScope.$apply();
                                    }
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                video: function (node) {
                    if ($scope.video && $scope.form.video.$valid === true) {
                        var fd = new FormData();
                        fd.append('video', $scope.video.file);
                        fd.append('name', $scope.video.name);

                        var video = $scope.video;
                        $scope.progress.videos.push({
                            name: video.name,
                        });

                        webinarFactory
                            .videos(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.videos = $array.$splice(
                                    $scope.progress.videos,
                                    { name: video.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.videos.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.video ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                picture: function (node) {
                    if ($scope.picture && $scope.form.picture.$valid === true) {
                        webinarFactory
                            .picture(node.id)
                            .upload({
                                name: $scope.picture.name,
                                photo: $scope.picture.base,
                            })
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    webinarFactory
                                        .picture(node.id)
                                        .attach(response.data.data.id, {})
                                        .then(function (response) {
                                            if (response.data.state === 0) {
                                                node.picture = response.data.data;
                                            }
                                        });
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.photo ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
                document: function (node) {
                    if ($scope.document && $scope.form.document.$valid === true) {
                        var fd = new FormData();
                        fd.append('document', $scope.document.file);
                        fd.append('name', $scope.document.name);

                        var document = $scope.document;
                        $scope.progress.documents.push({
                            name: document.name,
                        });

                        webinarFactory
                            .documents(node.id)
                            .upload(fd, {
                                transformRequest: angular.identity,
                                headers: { 'Content-Type': undefined },
                            })
                            .then(function (response) {
                                $scope.progress.documents = $array.$splice(
                                    $scope.progress.documents,
                                    { name: document.name },
                                    'name'
                                );

                                if (response.data.state === 0) {
                                    $scope.documents.unshift(response.data.data);
                                } else {
                                    $root.$broadcast('graph-modal-show', {
                                        title: 'Error',
                                        content:
                                            response.data.data.document ||
                                            'The file is too large or the format is incorrect.',
                                    });
                                }
                            });
                    }
                },
            };

            function uploadAndAttachPhoto(webinarEntry, file, attachFunc) {
                if (!webinarEntry.id) {
                    return $q.reject('Passed Webinar object does not have an id prop');
                }

                if (!file) {
                    return $q.reject('File object not provided');
                }

                return webinarFactory
                    .uploadWebinarPhoto(webinarEntry.id, {
                        name: file.name,
                        data64: file.base,
                    })
                    .then(attachFunc)
                    .catch(function () {
                        $root.$broadcast('graph-modal-show', {
                            title: 'Error',
                            content: 'The file is too large or the format is incorrect.',
                        });
                    });
            }

            function uploadHeaderImage(webinarEntry, file) {
                uploadAndAttachPhoto(webinarEntry, file, function (photoObj) {
                    return webinarFactory.attachHeaderImage(webinarEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    webinarEntry.picture = photoEntry;
                });
            }

            function uploadDescriptionImage(webinarEntry, file) {
                uploadAndAttachPhoto(webinarEntry, file, function (photoObj) {
                    return webinarFactory.attachDescriptionImage(webinarEntry.id, photoObj.id);
                }).then(function (photoEntry) {
                    webinarEntry.description_image = photoEntry;
                });
            }

            $scope.delete = {
                photo: function (node, index) {
                    webinarFactory
                        .photos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.photos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.photo ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                video: function (node, index) {
                    webinarFactory
                        .videos($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.videos.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.video ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
                document: function (node, index) {
                    webinarFactory
                        .documents($scope.node.id)
                        .delete(node.id)
                        .then(function (response) {
                            if (response.data.state === 0) {
                                $scope.documents.splice(index, 1);
                            } else {
                                $root.$broadcast('graph-modal-show', {
                                    title: 'Error',
                                    content:
                                        response.data.data.document ||
                                        'An error occurred in the remove. Please try again later',
                                });
                            }
                        });
                },
            };

            $socket.on('comment:create', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            ++node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $socket.on('comment:delete', function (data) {
                if (data.place.name === 'post') {
                    $scope.posts.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            --node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $scope.load = {
                timeline: function (next) {
                    ++$scope.params.timeline.page;
                    webinarFactory
                        .posts($scope.node.id)
                        .query({ params: $scope.params.timeline })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.posts = $scope.posts.concat(response.data.data);

                                $socket.emit(
                                    'join:post',
                                    response.data.data.map(function (item) {
                                        return item.id;
                                    })
                                );

                                if (next) next();
                            }
                        });
                },
                requests: function (next) {
                    $scope.Request.Query(next);
                },
                loadDocuments: function loadDocuments(pagination) {
                    // cancel previous request
                    canceler.resolve();
                    canceler = $q.defer();

                    $scope.params.documents.page = pagination.page;

                    return webinarFactory
                        .documents($scope.node.id)
                        .query({
                            // pass pagination and filters
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            $scope.documents = $scope.documents.concat(response.data.data);
                            // return pagination info for <load-more-button> component
                            return {
                                totalItems: response.data.total,
                                totalPages: response.data.pages,
                            };
                        });
                },
                documents: function (next) {
                    canceler.resolve();
                    canceler = $q.defer();

                    ++$scope.params.documents.page;
                    webinarFactory
                        .documents($scope.node.id)
                        .query({
                            params: $scope.params.documents,
                            timeout: canceler.promise,
                        })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.documents = $scope.documents.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                photos: function (next) {
                    ++$scope.params.photos.page;
                    webinarFactory
                        .photos($scope.node.id)
                        .query({ params: $scope.params.photos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.photos = $scope.photos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
                videos: function (next) {
                    ++$scope.params.videos.page;
                    webinarFactory
                        .videos($scope.node.id)
                        .query({ params: $scope.params.videos })
                        .then(function (response) {
                            if (response.data.state === 0 && response.data.data.length > 0) {
                                $scope.videos = $scope.videos.concat(response.data.data);

                                if (next) next();
                            }
                        });
                },
            };

            $scope.$on('touch:request', function () {
                $scope.load.requests();
            });

            $scope.filter.on.change = function () {
                $flex.$scroll.switch($scope.filter.tab());
            };

            $scope.$on('touch:timeline', function () {
                $scope.load.timeline();
            });

            $scope.$on('touch:video', function () {
                $scope.load.videos();
            });

            $scope.$on('touch:photo', function () {
                $scope.load.photos();
            });

            $scope.$on('touch:document', function () {
                $scope.documentsPagination = new $paginationFactory.paginate(function (params) {
                    return webinarFactory
                        .documents($scope.node.id)
                        .query({ params: params })
                        .then(function (response) {
                            return {
                                items: response.data.data,
                                totalPages: response.data.pages,
                            };
                        });
                });

                /**
                 * @param {PaginateData} paginationData
                 */
                $scope.documentsPagination.onPageLoad = function (paginationData) {
                    $scope.documents = [].concat($scope.documents, paginationData.items);
                };

                $scope.documentsPagination.onReset = function () {
                    $scope.documents = [];
                };

                $scope.$on('document-filter-update', function ($e, queryFilters) {
                    $scope.documentsPagination.reset({ queryFilters: queryFilters });
                });
            });

            $scope.$on('web-meeting:open', (event) => {
                $scope.webMeting = {
                    open: true,
                };
            });

            $scope.openJoinEventLink = function (link) {
                event.stopPropagation();

                $window.open(link, '_blank');
            };

            $scope.requestWebClientIframe = function ($event) {
                const meetingId = $event.target?.dataset?.meetingId;
                if (meetingId) {
                    MeetingService.openVideoConferencePopup(meetingId);
                    return
                }

                MeetingService.triggerMeetingIframe('webinar', $scope.node.id);
            };

            $scope.$on('touch:participant', function () {
                $scope.participants.Query();
            });

            $scope.$on('$historyBack', $filter.init);

            $socket.on('post:create', function (message) {
                if (
                    $scope.posts
                        .map(function (item) {
                            return Number(item.id);
                        })
                        .indexOf(Number(message.node.id)) === -1
                ) {
                    if (message.place.name === 'webinar' && Number(message.place.id) === Number($scope.node.id)) {
                        $socket.emit('join:post', [message.node.id]);

                        if ($rootScope.me && message.node.owner.id === $rootScope.me.id) {
                            $scope.posts.unshift(message.node);

                            if (!$scope.$$phase) $scope.$digest();
                        } else {
                            $updates.appendUpdate(message.node);
                        }
                    }
                }
            });

            $scope.showUpdates = function () {
                return $updates.updatesQueue.length > 0;
            };

            $scope.cleanUpdates = function () {
                var updatesQueue = $updates.cleanUpdates();
                var defaultNodes = $scope.posts;
                $scope.posts = updatesQueue.concat(defaultNodes);
            };

            setTimeout(function () {
                window.scrollTo(0, 0);
            }, 2000);
        },
    ])
    .controller('reccuring-dates-modal.controller', [
        '$scope',
        'contest.service',
        function ($scope, $service) {
            $scope.opened = false;

            $scope.options = [];
            $scope.contestName = '';
            $scope.alreadyThere = false;
            $scope.loading = false;

            $scope.$on('open:reccuring-dates:modal', function (event, data) {
                $scope.opened = true;
                $scope.node = data;
                $scope.loading = true;
            });

            $scope.closeDialog = function () {
                $scope.opened = false;
            };
        },
    ]);
